export default function AdminApplications({ ctx }) {
  const { applications, decide, resendInvite, removeApp } = ctx;
  return (
    <div className="mt-10 space-y-3">
      {applications.length === 0 ? <p className="text-[#121212]/60">No applications yet.</p> :
        applications.map((a) => (
          <div key={a.id} data-testid={`app-${a.id}`} className="p-5 bg-white border-2 border-[#121212]">
            <div className="flex justify-between gap-4 flex-wrap">
              <div className="flex-1 min-w-0">
                <p className="font-serif font-black text-2xl">{a.class_name}</p>
                <p className="text-xs tracking-[0.2em] uppercase font-bold mt-1">{a.category} · {a.preferred_date} · {a.expected_attendance} attendees</p>
                <p className="text-sm text-[#121212]/80 mt-2">{a.class_description}</p>
                <p className="text-sm mt-3">{a.email} {a.instagram && `· ${a.instagram}`}</p>
                {a.notes && <p className="text-sm text-[#121212]/60 mt-2 italic">"{a.notes}"</p>}
                {a.photo_urls?.length > 0 && (
                  <div className="mt-3 flex gap-2 flex-wrap">{a.photo_urls.map((u, i) => <img key={i} src={u} alt="" className="w-16 h-16 object-cover border-2 border-[#121212]" />)}</div>
                )}
              </div>
              <div className="flex flex-col gap-2 items-end">
                <span className={`px-3 py-1 text-xs tracking-[0.2em] uppercase font-bold ${
                  a.status === "approved" ? "bg-[#C6FF33] border-2 border-[#121212]" :
                  a.status === "declined" ? "bg-[#FF8F80] border-2 border-[#121212]" :
                  "bg-white border-2 border-[#121212]"
                }`}>{a.status}</span>
                {a.status === "pending" && (
                  <div className="flex gap-2">
                    <button data-testid={`approve-${a.id}`} onClick={() => decide(a.id, "approved")} className="px-3 py-2 bg-[#121212] text-[#F2E9D8] text-xs tracking-[0.2em] uppercase font-bold">Approve</button>
                    <button data-testid={`decline-${a.id}`} onClick={() => decide(a.id, "declined")} className="px-3 py-2 border-2 border-[#121212] text-xs tracking-[0.2em] uppercase font-bold">Decline</button>
                  </div>
                )}
                <div className="flex gap-2">
                  {a.status === "approved" && (
                    <button data-testid={`resend-invite-${a.id}`} onClick={() => resendInvite(a.id)} className="px-3 py-2 border-2 border-[#121212] text-xs tracking-[0.2em] uppercase font-bold hover:bg-[#C6FF33]">Resend invite</button>
                  )}
                  <button data-testid={`delete-app-${a.id}`} onClick={() => removeApp(a.id)} className="px-3 py-2 border-2 border-[#FF8F80] text-[#c0392b] text-xs tracking-[0.2em] uppercase font-bold hover:bg-[#FF8F80] hover:text-[#121212]">Delete</button>
                </div>
              </div>
            </div>
          </div>
        ))}
    </div>
  );
}
